<template>
	<div ref="chart" style="width: 200px; height: 50px"></div>
</template>

<script>
import * as echarts from "echarts";

export default {
	props: {
		values: {
			type: Array,
			required: true,
		},
		maximum: {
			type: Number,
			required: true,
		},
		color: {
			type: String,
			default: "#A6A6A5",
		},
	},
	mounted() {
		let chartDom = this.$refs.chart,
			that = this,
			option = {
				xAxis: [
					{
						type: "value",
						max: 1.5 * this.maximum,
						axisLabel: {
							show: false,
						},
						axisLine: {
							show: false,
							lineStyle: {
								color: "#DFDFDE",
							},
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: "#EBEBEA",
							},
						},
					},
				],
				yAxis: {
					type: "category",
					axisLabel: {
						show: false,
					},
					axisLine: {
						show: true,
						lineStyle: {
							color: "#DFDFDE",
						},
					},
					splitLine: {
						show: true,
						lineStyle: {
							color: "#EBEBEA",
						},
					},
				},
				series: [
					{
						data: this.values,
						type: "bar",
						itemStyle: {
							color: this.color,
						},
						label: {
							show: true,
							position: "right",
							color: "#454545",
							formatter: function (d) {
								return d.data.toLocaleString(that.locale) + " t";
							},
						},
						barWidth: "30%",
						silent: true,
					},
				],
				textStyle: {
					fontFamily: "Barlow, Roboto, Helvetica, Arial, sans-serif",
					fontSize: "14",
					fontWeight: "500",
				},
				grid: {
					containLabel: false,
					left: "0px",
					right: "0px",
					top: "0px",
					bottom: "0px",
				},
			};

		this.myChart = echarts.init(chartDom);
		this.myChart.setOption(option);
	},
};
</script>
